// Simplified World Map SVG country paths (viewBox: 0 0 1000 500)
// Key country paths for choropleth mapping
export const WORLD_MAP_COUNTRIES = [
  // North America
  { code: "US", name: "United States", path: "M150 140 L280 140 L285 220 L240 240 L160 220 L130 180 Z M60 70 L120 70 L110 110 L50 100 Z" },
  { code: "CA", name: "Canada", path: "M110 60 L320 60 L300 135 L145 135 L125 90 Z" },
  { code: "MX", name: "Mexico", path: "M160 225 L230 240 L240 280 L200 300 L170 260 Z" },
  { code: "CU", name: "Cuba", path: "M245 230 L275 240 L260 245 Z" },
  { code: "PA", name: "Panama", path: "M240 285 L265 295 L255 305 Z" },

  // South America
  { code: "BR", name: "Brazil", path: "M300 320 L380 330 L390 400 L340 430 L300 380 Z" },
  { code: "AR", name: "Argentina", path: "M300 390 L340 395 L330 480 L290 470 Z" },
  { code: "CO", name: "Colombia", path: "M260 305 L295 310 L285 350 L255 330 Z" },
  { code: "CL", name: "Chile", path: "M285 390 L300 390 L290 480 L280 475 Z" },
  { code: "PE", name: "Peru", path: "M260 340 L290 345 L285 390 L265 375 Z" },
  { code: "VE", name: "Venezuela", path: "M290 295 L335 300 L325 325 L290 320 Z" },

  // Europe
  { code: "GB", name: "United Kingdom", path: "M450 140 L470 135 L475 165 L455 170 Z M440 150 L450 150 L445 165 Z" },
  { code: "FR", name: "France", path: "M465 175 L500 170 L510 205 L470 215 Z" },
  { code: "DE", name: "Germany", path: "M500 150 L535 150 L530 185 L495 185 Z" },
  { code: "IT", name: "Italy", path: "M505 195 L530 195 L535 240 L520 245 L500 210 Z" },
  { code: "ES", name: "Spain", path: "M435 205 L475 205 L465 245 L430 240 Z" },
  { code: "PT", name: "Portugal", path: "M425 210 L440 210 L435 240 L425 235 Z" },
  { code: "NL", name: "Netherlands", path: "M490 148 L505 148 L502 160 L488 158 Z" },
  { code: "BE", name: "Belgium", path: "M485 160 L500 160 L498 172 L483 170 Z" },
  { code: "CH", name: "Switzerland", path: "M495 185 L515 185 L512 198 L493 197 Z" },
  { code: "SE", name: "Sweden", path: "M515 80 L540 80 L535 150 L515 145 Z" },
  { code: "NO", name: "Norway", path: "M495 85 L520 85 L515 150 L490 140 Z" },
  { code: "FI", name: "Finland", path: "M540 75 L570 75 L565 130 L535 130 Z" },
  { code: "PL", name: "Poland", path: "M535 150 L575 150 L570 185 L530 185 Z" },
  { code: "UA", name: "Ukraine", path: "M570 160 L635 165 L625 205 L565 200 Z" },
  { code: "RU", name: "Russia", path: "M570 70 L910 80 L880 160 L570 160 Z" },
  { code: "IE", name: "Ireland", path: "M435 145 L450 145 L445 165 L430 160 Z" },
  { code: "AT", name: "Austria", path: "M515 180 L545 180 L540 195 L512 195 Z" },
  { code: "GR", name: "Greece", path: "M545 220 L570 220 L565 245 L540 240 Z" },

  // Asia & Middle East
  { code: "IN", name: "India", path: "M660 225 L730 225 L720 310 L680 325 L655 270 Z" },
  { code: "CN", name: "China", path: "M690 165 L840 170 L830 255 L730 260 L700 215 Z" },
  { code: "JP", name: "Japan", path: "M860 175 L885 175 L875 230 L850 220 Z" },
  { code: "KR", name: "South Korea", path: "M825 195 L845 195 L840 215 L822 210 Z" },
  { code: "ID", name: "Indonesia", path: "M760 330 L870 335 L860 370 L750 365 Z" },
  { code: "TH", name: "Thailand", path: "M740 265 L765 265 L760 315 L738 310 Z" },
  { code: "VN", name: "Vietnam", path: "M765 260 L785 260 L775 320 L760 315 Z" },
  { code: "MY", name: "Malaysia", path: "M750 320 L780 320 L775 340 L748 335 Z" },
  { code: "PH", name: "Philippines", path: "M820 270 L845 270 L835 325 L815 315 Z" },
  { code: "SG", name: "Singapore", path: "M755 338 L762 338 L760 344 L754 343 Z" },
  { code: "PK", name: "Pakistan", path: "M635 210 L675 215 L665 265 L630 255 Z" },
  { code: "BD", name: "Bangladesh", path: "M725 240 L745 240 L740 265 L722 260 Z" },
  { code: "SA", name: "Saudi Arabia", path: "M585 240 L650 245 L635 305 L575 295 Z" },
  { code: "AE", name: "United Arab Emirates", path: "M635 265 L655 265 L650 280 L632 278 Z" },
  { code: "TR", name: "Turkey", path: "M560 195 L630 195 L625 225 L555 220 Z" },
  { code: "IL", name: "Israel", path: "M575 230 L590 230 L588 245 L573 245 Z" },

  // Africa
  { code: "EG", name: "Egypt", path: "M535 235 L585 235 L580 280 L530 275 Z" },
  { code: "ZA", name: "South Africa", path: "M535 400 L585 400 L575 465 L525 460 Z" },
  { code: "NG", name: "Nigeria", path: "M475 295 L515 295 L510 335 L470 330 Z" },
  { code: "KE", name: "Kenya", path: "M570 320 L605 320 L600 360 L565 355 Z" },
  { code: "MA", name: "Morocco", path: "M430 240 L470 240 L460 275 L425 270 Z" },
  { code: "DZ", name: "Algeria", path: "M460 245 L515 245 L505 305 L450 300 Z" },
  { code: "GH", name: "Ghana", path: "M460 305 L480 305 L478 335 L458 332 Z" },
  { code: "ET", name: "Ethiopia", path: "M585 300 L630 305 L620 345 L575 340 Z" },

  // Oceania
  { code: "AU", name: "Australia", path: "M800 365 L925 365 L910 455 L810 460 Z" },
  { code: "NZ", name: "New Zealand", path: "M940 440 L965 440 L955 480 L935 475 Z" },
];

export const getCountryColor = (count, maxCount, isDark) => {
  if (!count || count <= 0) {
    return isDark ? "#1e293b" : "#e2e8f0";
  }
  const ratio = Math.min(count / (maxCount || 1), 1);
  if (isDark) {
    // Teal/cyan palette from low to high in dark mode
    if (ratio < 0.25) return "#0f766e";
    if (ratio < 0.5) return "#0d9488";
    if (ratio < 0.75) return "#14b8a6";
    return "#38bdf8";
  } else {
    // Teal/blue palette in light mode
    if (ratio < 0.25) return "#99f6e4";
    if (ratio < 0.5) return "#2dd4bf";
    if (ratio < 0.75) return "#0d9488";
    return "#0369a1";
  }
};
